import React from 'react';
import { ArrowRight } from 'lucide-react';
export const Navbar = () => {
  return <nav className="sticky top-0 z-50 flex justify-between items-center px-6 py-4 backdrop-blur-md bg-[#F6F4ED]/85" data-id="element-272">
      {/* Left: Logo */}
      <div className="flex items-center" data-id="element-273">
        <img src="https://cdn.magicpatterns.com/uploads/fGZPmBEEuygEB5KaVQhdrS/logohorizontal.png" alt="Aurora" className="h-[72px]" data-id="element-274" />
      </div>

      {/* Center: Links (Desktop) */}
      <div className="hidden md:flex items-center gap-8 bg-white px-8 py-3 rounded-full shadow-soft" data-id="element-275">
        <a href="#como-funciona" className="text-ink-soft hover:text-rose transition-colors font-medium text-sm" data-id="element-276">
          Como funciona
        </a>
        <a href="#beneficios" className="text-ink-soft hover:text-rose transition-colors font-medium text-sm" data-id="element-277">
          Benefícios
        </a>
        <a href="#preco" className="text-ink-soft hover:text-rose transition-colors font-medium text-sm" data-id="element-278">
          Preço
        </a>
        <a href="#duvidas" className="text-ink-soft hover:text-rose transition-colors font-medium text-sm" data-id="element-279">
          Dúvidas
        </a>
      </div>

      {/* Right: CTA */}
      <a href="#preco" className="hidden md:flex items-center gap-3 bg-ink text-white pl-6 pr-2 py-2 rounded-full hover:bg-ink/90 transition-colors no-underline" data-id="element-280">
        <span className="font-medium text-sm" data-id="element-281">Assinar agora</span>
        <div className="w-8 h-8 bg-rose rounded-full flex items-center justify-center" data-id="element-282">
          <ArrowRight size={16} className="text-white" data-id="element-283" />
        </div>
      </a>

      {/* Mobile Menu Button */}
      <button className="md:hidden p-2 text-ink" data-id="element-284">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-285">
          <line x1="3" y1="12" x2="21" y2="12" data-id="element-286"></line>
          <line x1="3" y1="6" x2="21" y2="6" data-id="element-287"></line>
          <line x1="3" y1="18" x2="21" y2="18" data-id="element-288"></line>
        </svg>
      </button>
    </nav>;
};